import { button, buttonAccent, buttonShadow, title as titleStyle } from 'core/style';
import { createStyles } from 'core/style/injectSheet';
import { ITheme } from 'core/style/interfaces';

export const formItemCardStyles = (theme: ITheme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: 0.6 + 'rem',
            flexGrow: 1,
        },
        darkenedRoot: {
            position: 'relative',

            '&::after': {
                content: '""',
                position: 'absolute',
                zIndex: 1,
                top: 0,
                right: 0,
                left: 0,
                bottom: 0,
                background: 'rgba(43, 43, 43, 0.5)',
            },

            '& $button': {
                zIndex: 2,
            },
        },
        greyRect: {
            height: 175,
            cursor: 'pointer',
            position: 'relative',

            '&:hover': {
                '& $playButton': {
                    background: `url(${require('./play_button_red.png')}) no-repeat`,
                    transform: 'scale(0.8)',
                },
            },
        },
        playButton: {
            background: `url(${require('./play_button_black.png')}) no-repeat`,
            transition: 'all 300ms ease-in-out',
            transform: 'scale(0.6)',
            width: 96,
            height: 96,
            position: 'absolute',
            zIndex: 2,
            top: 'calc(50% - 48px)',
            left: 'calc(50% - 48px)',
        },
        videoPreviewImage: {
            overflow: 'hidden',
            minWidth: '100%',
            minHeight: '100%',
            width: '100%',
            height: '100%',
        },
        content: {
            background: '#ffffff',
            flexGrow: 1,
            color: '#1e252f',
            padding: '1.5rem 30px',
            display: 'flex',
            flexDirection: 'column',
            border: '#f7f7f7 1px solid',
            boxShadow: '0 0 3px #e6e6e6',

            '& p:last-child': {
                marginBottom: 0,
            },
        },
        title: {
            ...titleStyle({
                size: 'h3',
                color: 'black',
            }),
            fontSize: '1.15rem',
            marginBottom: '0.5rem',
        },
        icon: {
            width: 10,
            height: 12,
            fill: theme.colors.secondary,
            marginRight: 7,
        },
        teachers: {
            display: 'border',
            alignItems: 'center',
            marginTop: '-0.3rem',
            marginBottom: '0.5rem',
        },
        teacher: {
            fontSize: '0.6875rem',
            color: 'black',
            fontWeight: 'normal',
            textDecoration: 'none',
        },
        hours: {
            fontSize: 0.9 + 'rem',
            marginTop: -0.5 + 'rem',
            marginBottom: 0.5 + 'rem',
        },
        shortDesc: {
            marginBottom: '1.25rem',
            flexGrow: 50,
        },
        button: {
            ...button(theme),
            ...buttonAccent(theme),
            ...buttonShadow,
            display: 'block',
            fontWeight: 'bold',
        },
        buttonEnded: {
            verticalAlign: 'middle',
            textAlign: 'center',
            display: 'block',
            textDecoration: 'none',
            padding: 16,
            lineHeight: 1,
            border: 'none',
            color: 'white',
            fontWeight: 'bold',
        },
        addons: {
            display: 'flex',
            flex: '1 1 auto',
            flexGrow: 2,
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            margin: '10px -10px 0 -10px',

            [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
            },

            [theme.breakpoints.down('xs')]: {
                flexDirection: 'row',
            },
        },
        addons__button: {
            ...button(theme),

            border: '1.5px solid',
            borderColor: '#999999',
            color: '#999999',
            fontWeight: 'bold',
            fontSize: 16,
            maxHeight: 16,
            margin: '0 10px',
            flex: '1 1 auto',
            flexBasis: '40%',
            padding: '11px 0',

            transition: 'background-color 0.25s ease-out, color 0.25s ease-out',
            '&:hover': {
                borderColor: '#CCCCCC',
                color: '#CCCCCC',
            },

            [theme.breakpoints.down('md')]: {
                marginBottom: 10,
                flex: '0 0 auto',
            },

            [theme.breakpoints.down('xs')]: {
                marginBottom: 0,
                flexBasis: '40%',
                flex: '1 1 auto',
            },
        },
        viewedItem: {
            position: 'absolute',
            fontSize: '18px',
            fontWeight: 600,
            color: '#1e252f',
            top: 'calc(50% + 30px)',
            width: 100 + '%',
            textAlign: 'center',
        },
    });
